var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 498.11 97.95",
    style: {
      enableBackground: "new 0 0 498.11 97.95"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9A23A;}\n\t.st1{fill:#197CCE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.55,84.69L28.76,55.87H16.37v28.82H0V1.66h33.21c7.67,0,14.19,2.69,19.57,8.07 c5.38,5.38,8.07,11.86,8.07,19.45c0,5.14-1.46,9.9-4.39,14.29c-2.92,4.39-6.8,7.69-11.62,9.9l18.38,31.32H45.55z M16.37,16.96 v24.55h16.84c3.08,0,5.73-1.2,7.95-3.62c2.21-2.41,3.32-5.32,3.32-8.72c0-3.4-1.11-6.29-3.32-8.66c-2.22-2.37-4.86-3.56-7.95-3.56 H16.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.45,69.03h34.99v15.66H70.08V1.66h50.77v15.66h-34.4v17.67h31.43v15.42H86.45V69.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.05,86.35c-12.5,0-22.81-4.15-30.96-12.45c-8.15-8.3-12.22-18.54-12.22-30.72 c0-12.26,4.07-22.52,12.22-30.78C148.23,4.13,158.55,0,171.05,0c7.51,0,14.45,1.76,20.82,5.28c6.36,3.52,11.33,8.28,14.89,14.29 l-14.11,8.18c-2.06-3.72-4.98-6.62-8.78-8.72c-3.8-2.09-8.07-3.14-12.81-3.14c-8.07,0-14.57,2.53-19.51,7.59 c-4.94,5.06-7.41,11.62-7.41,19.69c0,7.99,2.47,14.51,7.41,19.57c4.94,5.06,11.45,7.59,19.51,7.59c4.74,0,9.03-1.05,12.87-3.14 c3.83-2.09,6.74-4.96,8.72-8.6l14.11,8.18c-3.56,6.01-8.5,10.78-14.83,14.29C185.6,84.59,178.64,86.35,171.05,86.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.29,84.69L293.42,1.66h17.79l20.3,63.83l20.14-63.83h17.91l-27.99,83.03H321.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.2,69.03h34.99v15.66h-51.36V1.66h50.77v15.66h-34.4v17.67h31.43v15.42H393.2V69.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M480.44,84.69l-16.78-28.82h-12.39v28.82h-16.37V1.66h33.21c7.67,0,14.19,2.69,19.57,8.07 c5.38,5.38,8.07,11.86,8.07,19.45c0,5.14-1.46,9.9-4.39,14.29c-2.92,4.39-6.8,7.69-11.62,9.9l18.38,31.32H480.44z M451.26,16.96 v24.55h16.84c3.08,0,5.73-1.2,7.95-3.62c2.21-2.41,3.32-5.32,3.32-8.72c0-3.4-1.11-6.29-3.32-8.66c-2.22-2.37-4.86-3.56-7.95-3.56 H451.26z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.18,46.98v-0.04c0-25.92-21.01-46.93-46.92-46.94c-21.95,0.01-39.75,17.81-39.75,39.76h0.01 c0,15.71,9.41,29.23,22.9,35.22c-8.79-5.3-14.66-14.94-14.66-25.94c0-16.72,13.55-30.27,30.27-30.27 c16.72,0,30.27,13.55,30.27,30.27c0,9.2-4.1,17.44-10.58,22.99l-2.15-3.08l-3.22,18.24l18.24,3.22l-2.29-3.26 C290.28,77.25,297.18,62.92,297.18,46.98z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.05,22.31c-0.39,0-0.7,0.31-0.7,0.7v4.19c0,0.39,0.31,0.7,0.7,0.7c0.39,0,0.7-0.31,0.7-0.7v-4.19 C249.75,22.62,249.44,22.31,249.05,22.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.13,23.22c-0.37,0.1-0.59,0.48-0.49,0.85l1.08,4.04c0.1,0.37,0.48,0.59,0.85,0.49 c0.37-0.1,0.59-0.48,0.49-0.85l-1.08-4.04C242.89,23.34,242.51,23.12,242.13,23.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.69,25.89c-0.33,0.19-0.45,0.62-0.26,0.95l2.09,3.63c0.19,0.33,0.62,0.45,0.95,0.26 c0.33-0.19,0.45-0.62,0.26-0.95l-2.09-3.63C236.45,25.81,236.02,25.7,235.69,25.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.15,30.14c-0.27,0.27-0.27,0.71,0,0.99l2.96,2.96c0.27,0.27,0.71,0.27,0.99,0 c0.27-0.27,0.27-0.71,0-0.99l-2.96-2.96C230.86,29.87,230.42,29.87,230.15,30.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.9,35.68c-0.19,0.33-0.08,0.76,0.26,0.95l3.63,2.09c0.33,0.19,0.76,0.08,0.95-0.26 c0.19-0.33,0.08-0.76-0.26-0.95l-3.63-2.09C226.52,35.23,226.09,35.34,225.9,35.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.23,42.13c-0.1,0.37,0.12,0.75,0.49,0.85l4.04,1.08c0.37,0.1,0.75-0.12,0.85-0.49 c0.1-0.37-0.12-0.75-0.49-0.85l-4.04-1.08C223.71,41.53,223.33,41.75,223.23,42.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.32,49.05c0,0.39,0.31,0.7,0.7,0.7h4.19c0.39,0,0.7-0.31,0.7-0.7c0-0.39-0.31-0.7-0.7-0.7h-4.19 C222.63,48.35,222.32,48.66,222.32,49.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.23,55.97c0.1,0.37,0.48,0.59,0.85,0.49l4.04-1.08c0.37-0.1,0.59-0.48,0.49-0.85 c-0.1-0.37-0.48-0.59-0.85-0.49l-4.04,1.08C223.35,55.21,223.13,55.59,223.23,55.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.9,62.41c0.19,0.33,0.62,0.45,0.95,0.26l3.63-2.09c0.33-0.19,0.45-0.62,0.26-0.95 c-0.19-0.33-0.62-0.45-0.95-0.26l-3.63,2.09C225.82,61.65,225.71,62.08,225.9,62.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.15,67.95c0.27,0.27,0.71,0.27,0.99,0l2.96-2.96c0.27-0.27,0.27-0.71,0-0.99 c-0.27-0.27-0.71-0.27-0.99,0l-2.96,2.96C229.88,67.24,229.88,67.68,230.15,67.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.69,72.2c0.33,0.19,0.76,0.08,0.95-0.26l2.09-3.63c0.19-0.33,0.08-0.76-0.26-0.95 c-0.33-0.19-0.76-0.08-0.95,0.26l-2.09,3.63C235.24,71.58,235.35,72.01,235.69,72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.42,72.2c0.33-0.19,0.45-0.62,0.26-0.95l-2.09-3.63c-0.19-0.33-0.62-0.45-0.95-0.26 c-0.33,0.19-0.45,0.62-0.26,0.95l2.09,3.63C261.66,72.28,262.09,72.39,262.42,72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.96,67.95c0.27-0.27,0.27-0.71,0-0.99L265,64c-0.27-0.27-0.71-0.27-0.99,0c-0.27,0.27-0.27,0.71,0,0.99 l2.96,2.96C267.24,68.22,267.69,68.22,267.96,67.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.21,62.41c0.19-0.33,0.08-0.76-0.26-0.95l-3.63-2.09c-0.33-0.19-0.76-0.08-0.95,0.26 c-0.19,0.33-0.08,0.76,0.26,0.95l3.63,2.09C271.59,62.86,272.01,62.75,272.21,62.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.88,55.97c0.1-0.37-0.12-0.75-0.49-0.85l-4.04-1.08c-0.37-0.1-0.75,0.12-0.85,0.49 c-0.1,0.37,0.12,0.75,0.49,0.85l4.04,1.08C274.4,56.56,274.78,56.34,274.88,55.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M275.79,49.05c0-0.39-0.31-0.7-0.7-0.7h-4.19c-0.39,0-0.7,0.31-0.7,0.7c0,0.39,0.31,0.7,0.7,0.7h4.19 C275.48,49.74,275.79,49.43,275.79,49.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M274.88,42.13c-0.1-0.37-0.48-0.59-0.85-0.49l-4.04,1.08c-0.37,0.1-0.59,0.48-0.49,0.85 c0.1,0.37,0.48,0.59,0.85,0.49l4.04-1.08C274.76,42.88,274.98,42.5,274.88,42.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.21,35.68c-0.19-0.33-0.62-0.45-0.95-0.26l-3.63,2.09c-0.33,0.19-0.45,0.62-0.26,0.95 c0.19,0.33,0.62,0.45,0.95,0.26l3.63-2.09C272.29,36.44,272.4,36.01,272.21,35.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.96,30.14c-0.27-0.27-0.71-0.27-0.99,0l-2.96,2.96c-0.27,0.27-0.27,0.71,0,0.99 c0.27,0.27,0.71,0.27,0.99,0l2.96-2.96C268.23,30.85,268.23,30.41,267.96,30.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.42,25.89c-0.33-0.19-0.76-0.08-0.95,0.26l-2.09,3.63c-0.19,0.33-0.08,0.76,0.26,0.95 c0.33,0.19,0.76,0.08,0.95-0.26l2.09-3.63C262.87,26.51,262.76,26.08,262.42,25.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.97,23.22c-0.37-0.1-0.75,0.12-0.85,0.49l-1.08,4.04c-0.1,0.37,0.12,0.75,0.49,0.85 c0.37,0.1,0.75-0.12,0.85-0.49l1.08-4.04C256.57,23.7,256.35,23.32,255.97,23.22z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.69,79.67h-17.33c-1.84,0-3.32,1.49-3.32,3.32c0,1.84,1.49,3.32,3.32,3.32h17.33 c1.84,0,3.32-1.49,3.32-3.32C261.02,81.16,259.53,79.67,257.69,79.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.22,91.3h-4.39c-1.84,0-3.32,1.49-3.32,3.32c0,1.84,1.49,3.32,3.32,3.32h4.39c1.84,0,3.32-1.49,3.32-3.32 C254.55,92.79,253.06,91.3,251.22,91.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3fa751047dae284a31db1e362b07ff20.svg";
export { ForwardRef as ReactComponent };